import React from 'react';
import { Switch } from 'react-router-dom';
import PaymentPage from '../../pages/Payment/PaymentPage';
import Route from '../../services/route';
import RouteWrapper from '../RouteWrapper';

export const paymentPublicRoute = new Route('/pay/:sessionToken');

export const PaymentRoutesComponent: React.FC = () => (
  <Switch>
    <RouteWrapper
      path={paymentPublicRoute.path}
      component={PaymentPage}
      isPrivate={false}
      exact
    />
  </Switch>
);
